// extracted by mini-css-extract-plugin
export default {"fallback":"loading-fallback_fallback__eJXGY"};